export default __webpack_public_path__ + "static/media/markerPoint-cameraView.0a2b74da.svg";